// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768px","container":"ContentfulC2A_container__GQ3wm","button":"ContentfulC2A_button__Ruv_i","supportButtons":"ContentfulC2A_supportButtons__vvxdX"};